// extracted by mini-css-extract-plugin
module.exports = {"component":"image-and-video-grid_component__BeP95","title":"image-and-video-grid_title__moDOn"};